<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <v-dialog v-if="isView" v-model="isView" persistent width="800">
        <v-card class="mt-3 pa-1">
            <v-card-title class="pa-0">
                <v-app-bar dense dark elevation="0" color="primary">
                    <v-list-item-title>
                        <!-- <v-icon>mdi-eye-circle</v-icon> -->
                        <span>収穫</span>
                    </v-list-item-title>
                    <TitleButton
                        icon="mdi-floppy"
                        name="保存"
                        @click="onClickSave()" />
                    <TitleButton
                        icon="mdi-close-circle"
                        name="閉じる"
                        @click="isView = false" />
                </v-app-bar>
            </v-card-title>
            <v-card-text class="pa-0">
                <v-container>
                    <!-- 編集用 -->
                    <v-form ref="form">
                        <v-row >
                            <v-col>
                                <DatePicker 
                                    label="作業日"
                                    v-model="editItems.date"
                                    dense />
                            </v-col>
                        </v-row>
                        <v-row >
                            <v-col>
                                <!-- <v-text-field v-model="editItems.num" clearable label="収穫数" outlined type="number" suffix="果"/> -->
                                <NumInput 
                                    v-model="editItems.num" 
                                    prepend-icon="mdi-fruit-cherries"
                                    clearable                                    
                                    suffix="果"
                                    label="収穫数" 
                                    outlined
                                    hide-details 
                                    type="text" 
                                    dense
                                    align="align-left" />
                            </v-col>
                            <v-col>
                                <v-select v-model="editItems.state" label="目的" outlined :items="states" item-text="text" item-value="value" hide-details dense />
                            </v-col>
                        </v-row>
                        <v-row >
                            <v-col>
                                <!-- <v-select v-if="places != null && places.length > 0" v-model="editItems.placeID" clearable label="場所" outlined :items="places" item-text="name" item-value="placeID"/> -->
                                <PlaceSelector v-if="places != null && places.length > 0" v-model="editItems.placeID" :places="places" :placeGroups="placeGroups"/>
                            </v-col>
                            <v-col>
                                <v-text-field v-if="places == null || editItems.placeID == null" v-model="editItems.placeName" clearable label="場所" item-text="text" outlined dense />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col>
                                <v-text-field 
                                    v-model="editItems.memo" 
                                    clearable 
                                    label="メモ" 
                                    outlined 
                                    type="text" 
                                    counter="50"
                                    :rules="[validatorMemoLength]" />
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
            </v-card-text>
        </v-card>
        <Confirm ref="confirm" />
    </v-dialog>
</template>

<script>
    import db from '@/firebase/firestore.js'
    import PlaceSelector from '@/components/seedling/items/SelectorPlace';
    import DatePicker from '@/components/tools/DatePicker';
    import TitleButton from '@/components/tools/TitleBarButton';
    import NumInput from '@/components/tools/SoftwareNumKeyboard'
    import Confirm from '@/components/tools/ConfirmDialog';
    export default {
        components: {
            PlaceSelector,
            DatePicker,
            TitleButton,
            NumInput,
            Confirm
        },
        props: {
            places: {
                type: Array,
                default: null
            },
            placeGroups: {
                type: Array,
                default: null
            },
        },
        data: function () {
            return {
                isView: false,
                targetSeedling: null,
                editItems: {
                    date: this.df_currentDateTime("yyyy-MM-dd"),
                    num: 0,
                    state: 0,
                    memo: "",
                    placeID: null,
                    placeName: "",
                },
                states: [
                    {value: 10, text:"観察"},
                    {value: 20, text:"出荷"},
                    {value: 99, text:"廃棄"},
                ],
                validatorMemoLength: value => value.length <= 50 || '50文字以内で入力して下さい。',
            }
        },
        methods: {
            onClickSave: function () {
                const userUID = this.$store.getters["userUID"]
                const self = this
                if (!this.$refs.form.validate()) {
                    this.$refs.confirm.show({
                        title: "入力エラー",
                        message: "入力項目を確認して下さい。",
                        width: 400,
                        buttonYes: "入力に戻る",
                        buttonNo: "",
                    })
                    return
                }
                this.$refs.confirm.show({
                    title: "収穫",
                    message: "収穫しますか？",
                    buttonYes: "収穫する",
                    buttonNo: "いいえ",
                    width: 400,
                    listenerYes: function () {
                        self.register()
                        return true
                    },
                })
            },
            register: function () {

                const userUID = this.$store.getters["userUID"]
                const self = this

                // 場所が未選択で、かつ手入力されている時
                var newPlace = null
                if (this.editItems.placeID == null && this.editItems.placeName.length > 0) {
                    var newPlaceID = 1
                    if (this.places != null && this.places.length > 0) {
                        newPlaceID = Math.max(...this.places.map(m => m.placeID)) + 1
                    }
                    newPlace = {
                        // version: "1.0.0",
                        // placeID: newPlaceID,
                        // name: this.editItems.placeName,
                        // register: {
                        //     userUID: userUID,
                        //     dateTime: this.df_currentDateTime()
                        // },
                        // updater: {
                        //     userUID: "",
                        //     dateTime: ""
                        // }
                        version: "1.0.0",
                        placeID: newPlaceID,
                        cultivationType: null,
                        name: this.editItems.placeName,
                        details: {
                            area: 0,
                            variety: {
                                cropID: 1,
                                varietyID: 1
                            }
                        },
                        address: {
                            postalCode: "",
                            pref: "",
                            city: "",
                            address1: "",
                            address2: "",
                            areaID: ""
                        },
                        placeGroupID: "",
                        isDeleted: false,
                        streamingURLs: [],
                        image: null,
                        groupUserAuthorities: ["browse", "work", "environment"],
                        managementAgrichemical: {
                            enabled: false,
                            target: null,
                            dateTime: "",
                            startDate: {
                                month: 1,
                                day: 1
                            },
                        },
                        memo: "",
                        register: {
                            userUID: userUID,
                            dateTime: this.df_currentDateTime()
                        },
                        updater: {
                            userUID: "",
                            dateTime: ""
                        },
                    }
                    this.editItems.placeID = newPlaceID
                }

                // 登録処理開始
                try {
                    var registeredHarvests = []
                    var batch = db.batch()
                    // 収穫データ
                    const placeHistory = this.targetSeedling.placeHistories[this.targetSeedling.placeHistories.length - 1]

                    for (var i=1; i<=this.editItems.num; i++) {

                        const harvest = {
                            varsion: "1.0.0",
                            seedlingID: this.targetSeedling.seedlingID,
                            seedlingPlace: {
                                place: placeHistory.place,
                                date: placeHistory.date,
                            },
                            harvestNo: this.targetSeedling.results.harvestedNum + i,
                            date: this.editItems.date,
                            state: this.editItems.state,
                            memo: this.editItems.memo,
                            currentPlace: this.editItems.placeID,
                            placeHistories: [
                                {
                                    type: 1,
                                    place: this.editItems.placeID,
                                    date: this.editItems.date,
                                    dateTime: this.df_currentDateTime(),
                                    userUID: userUID
                                }
                            ],
                            results: {
                                observatedNum: 0
                            },
                            register: {
                                userUID: userUID,
                                dateTime: this.df_currentDateTime()
                            },
                            updater: {
                                userUID: "",
                                dateTime: ""
                            }
                        }

                        registeredHarvests.push(harvest)
                        batch.set(db.collection("users").doc(userUID).collection("seedlings").doc(this.targetSeedling.seedlingID).collection("harvests").doc(""+harvest.harvestNo), harvest)
                    }
                    // 苗データ内の収穫数
                    this.targetSeedling.results.harvestedNum += (this.editItems.num * 1)
                    this.targetSeedling.updater = {
                        userUID: userUID,
                        dateTime: this.df_currentDateTime()
                    }
                    batch.update(
                        db.collection("users").doc(userUID).collection("seedlings").doc(this.targetSeedling.seedlingID), 
                        {
                            "results.harvestedNum": this.targetSeedling.results.harvestedNum,
                            "updater": this.targetSeedling.updater
                        }
                    )

                    // 場所
                    if (newPlace != null) {
                        batch.set(db.collection("users").doc(userUID).collection("places").doc(""+newPlace.placeID), newPlace)
                        this.$store.commit(
                            "managementItems/addUserPlace",
                            {
                                userUID: userUID,
                                placeData: this.$store.getters["managementItems/loggedInUserPlaceData"], 
                                place: newPlace
                            }
                        )
                    }

                    // コミット
                    batch.commit().then(function(){
                        self.$store.commit("notification", {message:"収穫データを登録しました。"})
                        if (newPlace != null) {
                            self.$emit("onRegisteredNewPlace", newPlace)
                        }
                        self.$emit("onRegisteredHarvests", registeredHarvests)
                        self.isView = false
                    }).catch(function(error){
                        console.log(error)
                        self.$store.commit("notification", {message:"収穫データの登録に失敗しました。", isError:true})
                    })
                } catch (error) {
                    console.log(error)
                    self.$store.commit("notification", {message:"収穫データの登録に失敗しました。", isError:true})
                }
            },
            show: function (targetSeedling) {
                this.targetSeedling = targetSeedling
                this.isView = true
            },
        }
    }
</script>
